import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  FormControlLabel,
  TextField,
  Typography,
} from '@material-ui/core';
import { Email } from '@material-ui/icons';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import CustomTextField from '../../../components/onboarding/CustomTextField';
import {
  COMPONENT_NAMES,
  SCREEN_NAMES,
  segmentEventApi,
  setUserAttribute,
  trackAnalyticsEvent,
} from '../../../constants/analyticsMeta';
import { CONTENT_AI_USER_TYPE, SUBSCRIPTION_STATUS } from '../../../constants/common';
import auth0 from 'auth0-js';
import { v4 as uuidv4 } from 'uuid';
import { StepperGetStarted } from './StepperGetstarted';
import { useQalert } from '../../../utility/services/customHooks';
import { USER_CLASSIFICATION } from '../../../utility/common';
import { signOut } from '../../../utility/services/authActions';

const VerifyToolsUser = ({ handleChangePlan, showStepper = false }) => {
  const planName = sessionStorage.getItem('selected-tools-plan') || 'Free';
  const toolsUser = sessionStorage.getItem('tools-user-auth');
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [planId, setPlanId] = useState('');
  const [checked, setChecked] = useState(false);
  const [checkboxError, setCheckboxError] = useState('');
  const [receiveEmailsChecked, setReceiveEmailsChecked] = useState(false);
  const [showRequestLoader, setShowRequestLoader] = useState(false);
  const [showCodeInput, setShowCodeInput] = useState(false);
  const [showVerifyLoader, setShowVerifyLoader] = useState(false);
  const [showSuccessEmailVerification, setShowSuccessEmailVerification] = useState(false);
  const [verifiedEmail, setVerifiedEmail] = React.useState(false);
  const [showCreatePassword, setShowCreatePassword] = useState(true);
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [code, setCode] = useState('');
  const [passwordError, setPasswordError] = useState<string[]>([]);
  const [userExists, setUserExists] = useState(false);
  const [createAccountLoading, setCreateAccountLoading] = useState(false);
  const [createGoogleAccountLoading, setCreateGoogleAccountLoading] = useState(false);
  const [_, toggleSnackBar] = useQalert();
  const [manualLogin, setManualLogin] = useState(false);

  const [error, setError] = useState<{
    email?: boolean;
    firstName?: boolean;
    lastName?: boolean;
    code?: boolean;
    password?: boolean;
    password2?: boolean;
  }>({});
  const [errorMessage, setErrorMessage] = useState<{
    email?: string;
    firstName?: string;
    lastName?: string;
    code?: string;
    password?: string;
    password2?: string;
  }>({});

  const [activeStep, setActiveStep] = React.useState(0);

  const router = useRouter();
  let qttr_tools_auth = Cookies.get('qttr_tools_auth');

  const handleSubmitAndVerify = async () => {
    let allValid = true; // Flag to track if all validations pass
    const newError = { ...error };
    const newErrorMessage = { ...errorMessage };
    try {
      setShowRequestLoader(true);
      if (!email) {
        newErrorMessage.email = '* Required';
        newError.email = true;
        allValid = false;
      } else if (
        !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          email
        )
      ) {
        newErrorMessage.email = 'invalid Email';
        newError.email = true;
        allValid = false;
      } else {
        newErrorMessage.email = '';
        newError.email = false;
      }
      if (!firstName) {
        newErrorMessage.firstName = '* Required';
        newError.firstName = true;
      } else {
        newErrorMessage.firstName = '';
        newError.firstName = false;
      }
      if (!lastName) {
        newErrorMessage.lastName = '* Required';
        newError.lastName = true;
      } else {
        newErrorMessage.lastName = '';
        newError.lastName = false;
      }
      if (!checked) {
        setCheckboxError(' Please indicate that you have read and agree to the Terms of Use and Privacy Policy!');
      }
      allValid = allValid && !newError.firstName && !newError.lastName && checked;
      if (allValid) {
        trackAnalyticsEvent({
          eventName: 'Verify Email Form Submitted',
          payload: {
            label: 'Verify Email Form shown',
            firstName,
            lastName,
            email,
            recieve_marketing_emails: receiveEmailsChecked,
            component_name: COMPONENT_NAMES.contentai_ai_tools,
            screen_name: SCREEN_NAMES.contentai_ai_tools,
          },
        });
        await axios.post(
          '/api/join-content-ai/request-otp',
          {
            email,
            fullName: `${firstName} ${lastName}`,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );
        setShowCodeInput(true);
        if (window && window.analytics) {
          window.analytics.identify(email, {
            email: email,
            name: `${firstName} ${lastName}`,
            schema: '',
            instance_type: 'Content AI',
            user_type: CONTENT_AI_USER_TYPE,
            company_name: '',
          });
        }
        setUserAttribute('firstName', firstName);
        setUserAttribute('lastName', lastName);
        setUserAttribute('email', email);
        setUserAttribute('recieve_marketing_emails', receiveEmailsChecked);
      }
    } catch (error) {
      console.error('error : handleSubmitAndVerify', error);
    } finally {
      setShowRequestLoader(false);
    }
    setErrorMessage(newErrorMessage);
    setError(newError);
  };

  const verifyOtp = async () => {
    const newError = { ...error };
    const newErrorMessage = { ...errorMessage };
    try {
      if (!code) {
        newErrorMessage.code = '* Required';
        newError.code = true;
      } else {
        newErrorMessage.code = '';
        newError.code = false;
      }
      setShowVerifyLoader(true);
      const res = await axios.post(
        '/api/join-content-ai/verify-otp',
        {
          email,
          otp: code,
          firstName,
          lastName,
          fullName: `${firstName} ${lastName}`,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      setVerifiedEmail(true);
      handleNext();
      setShowCodeInput(false);
      setShowCreatePassword(true);
      trackAnalyticsEvent({
        eventName: 'Verified Email with OTP',
        payload: {
          label: 'Verified Email with OTP',
          component_name: COMPONENT_NAMES.contentai_ai_tools,
          screen_name: SCREEN_NAMES.contentai_ai_tools,
        },
      });
      setUserAttribute('last_verified_at', new Date().toISOString());
      setUserAttribute('email_verified_with', 'Manual');
    } catch (error) {
      console.error('error : verifyOtp', error);
      newErrorMessage.code = 'Invalid OTP';
      newError.code = true;
    } finally {
      setShowVerifyLoader(false);
    }
    setErrorMessage(newErrorMessage);
    setError(newError);
  };
  const handleVerifyWithEmail = () => {
    const statePayload = {
      // Encode the current location or any other data you want to preserve
      redirectUri: '/get-started?tab=ai-tools',
      isFromUnlockOption: false,
    };
    trackAnalyticsEvent({
      eventName: 'Button click',
      eventFor: 'Custom Button',
      payload: {
        label: 'Complete Verification with google',
        component_name: COMPONENT_NAMES.contentai_ai_tools,
        screen_name: SCREEN_NAMES.contentai_ai_tools,
        isQwaDashboard: false,
      },
    });
    const state = encodeURIComponent(JSON.stringify(statePayload));
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=${process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID}&redirect_uri=${process.env.NEXT_PUBLIC_HOST_URL}/api/goauth/callback&scope=email%20profile&access_type=online&state=${state}`;
  };
  const validatePassword = (password: string, password2: string): boolean => {
    // Regular expressions for password rules
    const lengthRegex = /.{8,}/;
    const uppercaseRegex = /[A-Z]/;
    const lowercaseRegex = /[a-z]/;
    const digitRegex = /\d/;
    const specialCharRegex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

    // Error messages
    let errors: string[] = [];

    // Check if passwords match
    if (!password || !password2) {
      errors.push("Password fields can't be empty");
    } else if (password !== password2) {
      errors.push('Passwords provided do not match');
    }
    // Check password rules
    else if (!lengthRegex.test(password)) {
      errors.push('Should contain at least 8 characters');
    } else if (!uppercaseRegex.test(password)) {
      errors.push('Should contain one capital case letter');
    } else if (!lowercaseRegex.test(password)) {
      errors.push('Should contain one small case letter');
    } else if (!digitRegex.test(password)) {
      errors.push('Should contain one numerical digit');
    } else if (!specialCharRegex.test(password)) {
      errors.push('Should contain one special character');
    }
    setPasswordError(errors);
    return errors?.length === 0;
  };
  const handlePasswordSet = async () => {
    setCreateAccountLoading(true);
    const isValid = validatePassword(password, password2);

    if (isValid && !manualLogin) {
      try {
        let payload = {
          email: email,
          firstname: firstName,
          lastname: lastName,
          password: password,
          planId: planId,
          qwa_tools_subscription_status: SUBSCRIPTION_STATUS.SUBSCRIPTION_ACTIVATED,
        };

        const config = {
          method: 'POST',
          url: `/api/join-content-ai/setup-tools-user`,
          data: payload,
        };
        const response = await axios.request(config);
        if (response?.data?.data?.created_at) {
          if (window?.analytics) {
            window.analytics.track(`Created Account`, {
              option: `Created Account`,
              email: email,
              isQwaDashboard: false,
            });
          } else {
            segmentEventApi(
              `Created Account`,
              {
                option: `Created Account`,
                email: email,
                isQwaDashboard: false,
              },
              'track'
            );
          }
          await handleAutoLogin();
        } else {
          await handleAutoLogin();
          setUserExists(true);
          console.error('User Already Exists !');
          if (window?.analytics) {
            window.analytics.track(`User Already Exists`, {
              option: `User Already Exists`,
              email: email,
              isQwaDashboard: false,
            });
          } else {
            segmentEventApi(
              `User With Already Exists`,
              {
                option: `User Already Exists`,
                email: email,
                isQwaDashboard: false,
              },
              'track'
            );
          }
          setCreateAccountLoading(false);
          router.push('/login');
        }
      } catch (error) {
        setCreateAccountLoading(false);
        console.error('Error: creating new user ', error);
      }
    } else if (isValid && manualLogin) {
      await signOut({ callbackUrl: '/get-started?tab=ai-tools&&manualLogin=true', redirect: false });
      let payload = {
        email: email,
        newPassword: password,
      };

      const config = {
        method: 'POST',
        url: `/api/join-content-ai/update-tools-users-password`,
        data: payload,
      };

      const response = await axios.request(config);
      if (response?.data?.data) {
        await handleAutoLogin();
      } else {
        router.push('/login');
      }
    } else {
      setCreateAccountLoading(false);
    }
    if (window?.analytics) {
      window.analytics.track('Clicked on Create Account', {
        option: 'Clicked on Create Account',
        isValidPassword: isValid,
        isQwaDashboard: false,
      });
    } else {
      segmentEventApi(
        'Clicked on Create Account',
        {
          option: 'Clicked on Create Account',
          isValidPassword: isValid,
          isQwaDashboard: false,
        },
        'track'
      );
    }
  };
  const handleAutoLogin = async () => {
    try {
      setCreateAccountLoading(true);
      const state = uuidv4(); // Generates a new, unique state for each session
      sessionStorage.setItem('auth_state', state); // Store state in sessionStorage for later validation

      var auth0Obj = new auth0.WebAuth({
        domain: process.env.NEXT_PUBLIC_AUTH0_ISSUER_BASE_URL,
        clientID: process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID,
        connection: 'qwa-users-prod-db',
        scope: 'openid profile email',
        audience: process.env.NEXT_PUBLIC_AUTH0_AUDIENCE,
        responseType: 'code',
        redirectUri: `${process.env.NEXT_PUBLIC_HOST_URL}/user-auth`,
        state: state,
      });

      let payload = { email: email };
      const result = await auth0Obj.login({
        email: payload.email,
        realm: 'qwa-users-prod-db',
        password: password,
        onRedirecting: (doAuth) => {
          doAuth();
        },
      });
      if (result?.data) {
        console.log('Auto Login success !');
        if (window.analytics) {
          window.analytics.identify(`${payload?.email}`, {
            email: payload?.email,
          });
          window.analytics.track(`Auto Login Success`, {
            option: `Auto Login Success`,
            email: payload?.email,
            isQwaDashboard: true,
          });
        } else {
          segmentEventApi(
            `Auto Login Success`,
            {
              option: `Auto Login Success`,
              email: payload?.email,
              isQwaDashboard: true,
            },
            'track'
          );
        }
      }
    } catch (error) {
      console.error('Error', error);

      if (window.analytics) {
        window.analytics.track(`Unable to Auto Login`, {
          option: `Auto Login Error`,
          email: email,
          isQwaDashboard: false,
        });
      } else {
        segmentEventApi(
          `Unable to Auto Login`,
          {
            option: `Auto Login Error`,
            email: email,
            isQwaDashboard: false,
          },
          'track'
        );
      }
    }
  };

  const handleToolsSignupWithGoogle = async () => {
    setCreateGoogleAccountLoading(true);
    if (manualLogin) {
      router.push({
        pathname: '/api/google-signup-for-tools-user',
        query: {
          email,
          planId,
        },
      });
    } else {
      try {
        let payload = {
          email: email,
          firstname: firstName,
          lastname: lastName,
          planId: planId,
          qwa_tools_subscription_status: SUBSCRIPTION_STATUS.SUBSCRIPTION_ACTIVATED,
        };

        const config = {
          method: 'POST',
          url: `/api/join-content-ai/setup-tools-user-with-google`,
          data: payload,
        };
        const response = await axios.request(config);
        if (response?.data?.data?.created_at) {
          router.push({
            pathname: '/api/google-signup-for-tools-user',
            query: {
              email,
              planId,
            },
          });
          if (window.analytics) {
            window.analytics.track('Success', {
              label: 'Success creating tools account in auth0',
              reference: 'redirected to google auth page',
            });
          } else {
            const payload = {
              email: email,
              instance_type: USER_CLASSIFICATION.QWA_TOOLS,
              user_type: USER_CLASSIFICATION.QWA_TOOLS,
              label: 'Success creating tools account in auth0',
              reference: 'redirected to google auth page',
            };
            segmentEventApi('Success creating tools account in auth0', payload, 'track');
          }
        } else {
          if (window.analytics) {
            window.analytics.track('Error', { label: 'Error creating tools account with Google' });
          } else {
            const payload = {
              email: email,
              instance_type: USER_CLASSIFICATION.QWA_TOOLS,
              user_type: USER_CLASSIFICATION.QWA_TOOLS,
              label: 'Error creating tools account with Google',
            };
            segmentEventApi('Error', payload, 'track');
          }
        }
      } catch (error) {
        console.error('Error: creating new user ', error);
        if (window.analytics) {
          window.analytics.track('Error', { label: 'Error creating tools account with Google' });
        } else {
          const payload = {
            email: email,
            instance_type: USER_CLASSIFICATION.QWA_TOOLS,
            user_type: USER_CLASSIFICATION.QWA_TOOLS,
            label: 'Error creating tools account with Google',
          };
          segmentEventApi('Error', payload, 'track');
          setCreateGoogleAccountLoading(false);
        }
      }
    }
  };
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  useEffect(() => {
    const sessionUser = toolsUser ? JSON.parse(toolsUser) : null;

    if (sessionUser) {
      setEmail(sessionUser?.email);
      setFirstName(sessionUser?.firstName);
      setLastName(sessionUser?.lastName);
      setPlanId(sessionUser?.planId);
    }
  }, [toolsUser]);

  useEffect(() => {
    const manualLoginQuery = router?.query?.manualLogin;
    if (manualLoginQuery === 'true') {
      setManualLogin(true);
    }
  }, [router]);

  return (
    <div className="verify-tools-user-wrapper">
      {showStepper ? <StepperGetStarted activeStep={activeStep} /> : null}
      {showCodeInput ? (
        <div className="opt-verification-container">
          <Typography className="opt-verification-header">Complete verification to create account</Typography>
          <CustomTextField
            label="Enter Code"
            value={code}
            placeholder="000000"
            // fullWidth
            whiteBg
            error={error?.code}
            isOtp
            errorMessage={errorMessage?.code}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setCode(e.target.value);
            }}
            isOnToolsVerify={true}
          />

          <div className="reset-create-new-pass-btn">
            <Button
              fullWidth
              variant="contained"
              disabled={showVerifyLoader}
              className="create-new-pass-btn"
              onClick={verifyOtp}
            >
              {showVerifyLoader ? (
                <svg version="1.1" id="loader" style={{ fill: '#1D3557' }}>
                  <path id="one" d="M5,25H0V0h5V25z" />
                  <path id="two" d="M15,25h-5V0h5V25z" />
                  <path id="three" d="M25,25h-5V0h5V25z" />
                </svg>
              ) : null}
              {showVerifyLoader ? 'Please wait...' : 'Complete Verification'}
            </Button>
            <Button
              fullWidth
              variant="outlined"
              disabled={showRequestLoader}
              style={{
                borderRadius: '4.2px',
                border: '1px solid #1D3557',
              }}
              color="primary"
              className="resend-code-btn"
              onClick={handleSubmitAndVerify}
            >
              {showRequestLoader ? (
                <svg version="1.1" id="loader" style={{ fill: '#1D3557' }}>
                  <path id="one" d="M5,25H0V0h5V25z" />
                  <path id="two" d="M15,25h-5V0h5V25z" />
                  <path id="three" d="M25,25h-5V0h5V25z" />
                </svg>
              ) : null}
              {showRequestLoader ? 'Please wait...' : 'Resend Code'}
            </Button>
            <Typography
              className={`m-15`}
              onClick={() => {
                setShowCodeInput(false);
                setCode('');
              }}
            >
              {`<< `} <span style={{ textDecorationLine: 'underline' }}>{`Update your email address`}</span>
            </Typography>
          </div>
        </div>
      ) : showCreatePassword ? (
        <div className="pass-set-container">
          <Typography className={`pass-set-heading`}>Set Your Password</Typography>
          <Typography className={`pass-set-desc`}>We are creating account for {email}</Typography>
          {/* google signup for tools user */}

          <Box textAlign="center">
            <Button
              className={`sign-up-with-google mt-30`}
              onClick={() => {
                handleToolsSignupWithGoogle();
                if (window.analytics) {
                  window.analytics.track('Button Click', { label: 'signup with Google' });
                } else {
                  const payload = {
                    email: email,
                    name: '',
                    schema: '',
                    instance_type: USER_CLASSIFICATION.QWA_TOOLS,
                    user_type: USER_CLASSIFICATION.QWA_TOOLS,
                    label: 'signup with Google',
                  };
                  segmentEventApi('Button Click', payload, 'track');
                }
              }}
              disabled={createGoogleAccountLoading}
            >
              {createGoogleAccountLoading ? (
                <CircularProgress size={20} />
              ) : (
                <>
                  <svg
                    className={'google-svg'}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M23.04 12.6777C23.04 11.8623 22.9668 11.0782 22.8309 10.3254H12V14.7738H18.1891C17.9225 16.2113 17.1123 17.4293 15.8943 18.2448V21.1302H19.6109C21.7855 19.1282 23.04 16.18 23.04 12.6777Z"
                      fill="#4285F4"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M11.9999 23.9162C15.1049 23.9162 17.7081 22.8864 19.6108 21.1301L15.8943 18.2446C14.8645 18.9346 13.5472 19.3423 11.9999 19.3423C9.00471 19.3423 6.46948 17.3194 5.56516 14.6012H1.72311V17.5807C3.61539 21.3392 7.50448 23.9162 11.9999 23.9162Z"
                      fill="#34A853"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M5.56523 14.6015C5.33523 13.9115 5.20455 13.1745 5.20455 12.4165C5.20455 11.6585 5.33523 10.9215 5.56523 10.2315V7.25195H1.72318C0.944318 8.80445 0.5 10.5608 0.5 12.4165C0.5 14.2722 0.944318 16.0285 1.72318 17.581L5.56523 14.6015Z"
                      fill="#FBBC05"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M11.9999 5.49025C13.6883 5.49025 15.2043 6.07047 16.3961 7.21002L19.6945 3.91161C17.7029 2.05593 15.0997 0.916382 11.9999 0.916382C7.50448 0.916382 3.61539 3.49343 1.72311 7.25184L5.56516 10.2314C6.46948 7.5132 9.00471 5.49025 11.9999 5.49025Z"
                      fill="#EA4335"
                    />
                  </svg>{' '}
                  Complete Sign up with Google
                </>
              )}
            </Button>
            {manualLogin ? (
              <Typography className="email-miss-match-msg" align="center">
                Error: Google email does not match payment email. Please select same email or create password manually.
              </Typography>
            ) : null}
            <Box className="divider-section-container">
              <Box className="divider-section-box"></Box>
              <Typography className="divider-section-text" align="center">
                OR Choose a Password
              </Typography>
              <Box className="divider-section-box"></Box>
            </Box>
          </Box>
          <br />
          <br />
          <CustomTextField
            id="password"
            label="Set a new password"
            value={password}
            type="password"
            whiteBg
            error={error?.password}
            placeholder={'********'}
            errorMessage={errorMessage?.password}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setPassword(e.target.value);
            }}
          />
          <CustomTextField
            id="password2"
            label="Re-enter your new password"
            value={password2}
            type="password"
            whiteBg
            error={error?.password2}
            placeholder={'********'}
            errorMessage={errorMessage?.password2}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setPassword2(e.target.value);
            }}
          />
          {passwordError ? <Typography className="error-text">{passwordError}</Typography> : null}

          <Typography>Password must contain</Typography>
          <ul>
            <li>Atleast 8 characters</li>
            <li>One capital case letter, one small case letter</li>
            <li>One numerical digit</li>
            <li>One special character</li>
          </ul>
          <div className="complete-pmt-wrapper">
            <Button className="complete-pmt-btn" disabled={createAccountLoading} onClick={() => handlePasswordSet()}>
              {createAccountLoading ? <CircularProgress size={20} /> : 'Create Account'}
            </Button>
          </div>
        </div>
      ) : (
        <div className="create-account-wrapper">
          <Typography className={` tools-verify-heading`}>Create Account Now</Typography>
          <Typography className={`mb-10 tools-verify-description`}>
            You have selected {planName} Plan &nbsp;{' '}
            <span className="change-plan" onClick={handleChangePlan}>
              Change Plan
            </span>
          </Typography>

          <div className="verify-tools-user-container">
            <Button className="mt-10 google-email-verify-btn" onClick={handleVerifyWithEmail}>
              <svg
                className="google-svg-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M23.04 12.6777C23.04 11.8623 22.9668 11.0782 22.8309 10.3254H12V14.7738H18.1891C17.9225 16.2113 17.1123 17.4293 15.8943 18.2448V21.1302H19.6109C21.7855 19.1282 23.04 16.18 23.04 12.6777Z"
                  fill="#4285F4"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.9999 23.9162C15.1049 23.9162 17.7081 22.8864 19.6108 21.1301L15.8943 18.2446C14.8645 18.9346 13.5472 19.3423 11.9999 19.3423C9.00471 19.3423 6.46948 17.3194 5.56516 14.6012H1.72311V17.5807C3.61539 21.3392 7.50448 23.9162 11.9999 23.9162Z"
                  fill="#34A853"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.56523 14.6015C5.33523 13.9115 5.20455 13.1745 5.20455 12.4165C5.20455 11.6585 5.33523 10.9215 5.56523 10.2315V7.25195H1.72318C0.944318 8.80445 0.5 10.5608 0.5 12.4165C0.5 14.2722 0.944318 16.0285 1.72318 17.581L5.56523 14.6015Z"
                  fill="#FBBC05"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.9999 5.49025C13.6883 5.49025 15.2043 6.07047 16.3961 7.21002L19.6945 3.91161C17.7029 2.05593 15.0997 0.916382 11.9999 0.916382C7.50448 0.916382 3.61539 3.49343 1.72311 7.25184L5.56516 10.2314C6.46948 7.5132 9.00471 5.49025 11.9999 5.49025Z"
                  fill="#EA4335"
                />
              </svg>{' '}
              &nbsp; Create account with Google
            </Button>
            <Box className="divider-container" style={{ maxWidth: '350px', margin: '21px auto' }}>
              <Divider className="signup-divider" style={{ height: '0.5px' }} />
              <Typography variant="caption">OR Create Account with Email</Typography>
              <Divider className="signup-divider" style={{ height: '0.5px' }} />
            </Box>
            <CustomTextField
              label="Email address"
              value={email}
              type="email"
              whiteBg
              error={error?.email}
              placeholder={'john.doe@quattr.com'}
              errorMessage={errorMessage?.email}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setEmail(e.target.value);
              }}
            />
            <div className="name-container">
              <CustomTextField
                label="First name"
                value={firstName}
                placeholder="John"
                limitWidth
                whiteBg
                error={error?.firstName}
                errorMessage={errorMessage?.firstName}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setFirstName(e.target.value);
                }}
              />
              <CustomTextField
                label="Last name"
                value={lastName}
                limitWidth
                whiteBg
                placeholder="Doe"
                error={error?.lastName}
                errorMessage={errorMessage?.lastName}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setLastName(e.target.value);
                }}
              />
            </div>
            <div className="checks-container">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked}
                    onChange={(event) => {
                      setCheckboxError('');
                      setChecked(event.target.checked);
                    }}
                    style={{ color: checked ? '#51D497' : undefined, paddingTop: '0px', paddingBottom: '0px' }}
                    className={`${checkboxError ? 'error-text' : ''}`}
                  />
                }
                style={{ alignItems: 'center' }}
                label={
                  <div className={`secondaryText ${checkboxError ? 'error' : ''}`} style={{ fontSize: '12px' }}>
                    <div>
                      I agree to Quattr’s{' '}
                      <a
                        className={`${checkboxError ? 'error-text' : 'text-green'} ${'link'}`}
                        href={'/content-ai/terms'}
                        onClick={(e) => {
                          e.preventDefault();
                          if (window) {
                            window.parent.postMessage({ action: 'redirectURL', url: '/content-ai/terms' }, '*');
                          } else {
                            router.push('/content-ai/terms');
                          }
                        }}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ fontSize: '12px' }}
                      >
                        {' '}
                        terms of service
                      </a>{' '}
                      &amp;{' '}
                      <a
                        className={`${checkboxError ? 'error-text' : 'text-green'} ${'link'}`}
                        href={'/privacy-policy'}
                        onClick={(e) => {
                          e.preventDefault();
                          if (window) {
                            window.parent.postMessage({ action: 'redirectURL', url: '/privacy-policy' }, '*');
                          } else {
                            router.push('/privacy-policy');
                          }
                        }}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ fontSize: '12px' }}
                      >
                        privacy policy
                      </a>
                      .
                    </div>
                  </div>
                }
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={receiveEmailsChecked}
                    onChange={(event) => {
                      setReceiveEmailsChecked(event.target.checked);
                    }}
                    style={{
                      color: receiveEmailsChecked ? '#51D497' : undefined,
                      paddingTop: '0px',
                      paddingBottom: '0px',
                    }}
                  />
                }
                style={{ alignItems: 'center' }}
                label={
                  <div className={`secondaryText`} style={{ fontSize: '12px' }}>
                    <div>I would like to receive marketing emails from Quattr.</div>
                  </div>
                }
              />
            </div>
            <div>
              <Button
                fullWidth
                variant="contained"
                disabled={showRequestLoader}
                className={'verify-email-btn'}
                onClick={handleSubmitAndVerify}
              >
                {showRequestLoader ? (
                  <svg version="1.1" id="loader" style={{ fill: '#1D3557' }}>
                    <path id="one" d="M5,25H0V0h5V25z" />
                    <path id="two" d="M15,25h-5V0h5V25z" />
                    <path id="three" d="M25,25h-5V0h5V25z" />
                  </svg>
                ) : null}
                {showRequestLoader ? 'Please wait...' : 'Verify Email with Code'}
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VerifyToolsUser;
